import {
  setExpireTime,
  checkExpireTimeIsUp,
  resetExpireTime,
} from '../../../scripts/utils/localstorage';

export class Modal extends HTMLElement {
  constructor() {
    super();

    this.key = null;
    this.HIDE_POPUP_VALUE = 'closed';
    this.expirationDays = 3;
  }

  connectedCallback() {
    const dataPageUrl = this.dataset.pageUrl;
    const pagePopupId = this.dataset.popupId;

    this.key = pagePopupId || dataPageUrl;
    this.expirationDays = Number(this.dataset.popupExpiration) || 3;

    this.init();
  }

  init() {
    if (!this.shouldShow()) return;

    this.show();
    this.bindEvents();
  }

  shouldShow() {
    if (!this.key) return false;

    const isExpired = !checkExpireTimeIsUp(this.key);
    const currentValue = localStorage.getItem(this.key);

    if (!isExpired && currentValue === this.HIDE_POPUP_VALUE) {
      return false;
    }

    if (isExpired) {
      localStorage.removeItem(this.key);
      resetExpireTime(this.key);
    }

    return true;
  }

  show() {
    this.style.display = 'block';
    document.body.style.overflow = 'hidden';
  }

  hide() {
    this.style.display = 'none';
    document.body.style.overflow = '';

    if (this.key) {
      localStorage.setItem(this.key, this.HIDE_POPUP_VALUE);

      const expireAt = Number(
        new Date().setDate(new Date().getDate() + this.expirationDays)
      );

      setExpireTime(this.key, expireAt);
    }
  }

  bindEvents() {
    this.querySelector('[data-close]')?.addEventListener('click', () =>
      this.hide()
    );
    this.querySelector('[data-overlay]')?.addEventListener('click', () =>
      this.hide()
    );

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') this.hide();
    });
  }
}
